import { type FC } from 'react';
import {
  uiStyles,
  UiButtonProps,
  UiText,
  UiTextProps,
  UiButton,
} from '@/lib/ui';

export type Theme = 'primary' | 'brand' | 'gray' | 'green' | 'red';

export interface ThemeButtonProps extends Omit<UiButtonProps, 'variant'> {
  children?: string,
  theme?: Theme,
}

interface ThemeColor {
  background: UiButtonProps['bgColor'],
  font: UiTextProps['color'],
}

// interface ThemeColorDictionary {
//   [key: Theme]: {
//     background: UiButtonProps['bgColor'],
//     font: UiTextProps['color'],
//   },
// }

const themeColorDictionary = {
  primary: {
    background: 'primary.50',
    font: 'primary.800',
  },
  brand: {
    background: 'brand.50',
    font: 'brand.600',
  },
  gray: {
    background: 'gray.100',
    font: 'text.primary',
  },
  green: {
    background: 'green.50',
    font: 'green.600',
  },
  red: {
    background: 'red.50',
    font: 'red.600',
  },
};

function getThemeColor(theme: Theme): ThemeColor  {
  if (!themeColorDictionary.hasOwnProperty(theme)) {
    return themeColorDictionary['primary'];
  }
  return themeColorDictionary[theme];
}

const ThemeButton: FC<ThemeButtonProps> = ({
  children,
  theme = 'primary' as Theme,
  ...props
}) => {
  const themeColor = getThemeColor(theme);

  return (
    <UiButton
      borderRadius={uiStyles.buttonRadius}
      bgColor={themeColor.background}
      size={'lg'}
      px={4}
      _loading={{
        color: themeColor.font,
      }}
      // py={4}
      // variant={'filled'}
      {...props}
    >
      {!!children && (
        <UiText color={themeColor.font} px={0}>{children}</UiText>
      )}
    </UiButton>
  );
};

export default ThemeButton;
